import { tokens } from "@/shared/design-system/tokens";
import styled from "@emotion/styled";

export const EmptyStateContainer = styled.div`
  text-align: center;
  max-width: 500px;
  margin: 0 auto;
`;

export const EmptyElements = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding-top: 20px;
  color: ${tokens.colors.basics[0]};
  p {
    white-space: pre-line;
  }
`;